module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Black.bc43a49.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Black/SFProDisplay-Black.ttf
// module id = qy2V
// module chunks = 16